// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"styles_buttonWrapper__BWCgg","button":"styles_button__b8Eeg"};